module.exports = __webpack_public_path__ + "images/assets/88fafb6bec094442180d8e66b5223c74.svg";